import { localStorageGet } from "./localStorageHelper";

export const getBirthdate = birthday => new Date(
  localStorageGet('dob').birthday.split(' / ').join('/')
).getTime();
